import { Component, OnDestroy, OnInit } from "@angular/core";
import { Store, select } from "@ngrx/store";
import { Observable } from "rxjs";
import { atualizarStatusConexao } from "src/app/refact/shared/components/teste-conexao/status-conexao/store/status-conexao.actions";
import { StatusConexaoState } from "src/app/refact/shared/components/teste-conexao/status-conexao/store/status-conexao.state";

@Component({
  selector: "app-status-conexao",
  templateUrl: "./status-conexao.component.html",
  styleUrls: ["./status-conexao.component.scss"],
})
export class StatusConexaoComponent implements OnInit, OnDestroy {
  private onOnline  = () => this.despachar(true);
  private onOffline = () => this.despachar(false);

  protected status: boolean = true;
  protected ocultarPopup: boolean = false;
  protected semConexao: string = "Sem conexão com a Internet";
  protected comConexao: string = "Conectado à Internet";
  protected statusConexao$: Observable<boolean>;

  constructor(
    private store: Store<{ statusConexao: StatusConexaoState }>
  ) {
    this.statusConexao$ = this.store
      .select("statusConexao")
      .pipe(select("conectado"));
  }

  ngOnInit(): void {
    this.despachar(navigator.onLine);
    window.addEventListener("online",  this.onOnline);
    window.addEventListener("offline", this.onOffline);
  }

  ngOnDestroy(): void {
    window.removeEventListener("online",  this.onOnline);
    window.removeEventListener("offline", this.onOffline);
  }

  private despachar(conectado: boolean): void {
    if (conectado !== this.status) {
      this.status = conectado;
      if (conectado) this.ocultarPopup = false;
      this.store.dispatch(atualizarStatusConexao({ conectado }));
    }
  }
}
